<div particleHelpNotes helpNoteId="data-survey-select-data" class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="flex flex-col full-grow-no-shrink-no-basis">
    <mat-tab-group class="custom-mat-tab"
                   *ngIf="!hasSelection && survey && survey.dataSections && survey.dataSections.length"
                   (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
      <mat-tab *ngFor="let section of survey.dataSections; let i = index" label="{{section.header}}">
        <ng-template mat-tab-label>
          <div class="custom-tab-header flex flex-row justify-start items-center">
            <div class="flex flex-col justify-start items-center">
              <div class="header">{{section.header}}</div>
              <div class="tool-name">{{section.toolName}}</div>
            </div>
          </div>
        </ng-template>
        <div *ngIf="i === selectedFieldSectionIndex" class="content pos-relative m-30 flex flex-col">
          <div *ngIf="section.config.Editor=='EntitySelectorComponent'" class="keno-grid-container">
            <particle-entity-selector [filterId]="section.config.EXECUTION_ID"
                                      [endpointName]="section.config.EndpointName"
                                      [filterTemplateId]="section.config.FilterTemplateId"
                                      [invalidateSubject]="invalidateSubjectList[i]"
                                      [leftSourceType]="section.sectionId"
                                      [itemType]="section.sectionId"
            >
            </particle-entity-selector>
          </div>
          <div *ngIf="section.config.Editor=='DynamicTransferBoxComponent'" class="keno-grid-container">
            <!-- <particle-transaction-selector [filterId]="section.config.EXECUTION_ID" [invalidateSubject]="invalidateSubjectTransaction">
             </particle-transaction-selector>-->
            <particle-dynamic-transfer-box [filterId]="section.config.EXECUTION_ID"
                                           [invalidateSubject]="invalidateSubjectList[i]"
                                           [leftSourceKey]="section.config.LeftSourceKey"
                                           [rightSourceKey]="section.config.RightSourceKey">
            </particle-dynamic-transfer-box>

          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div *ngIf="hasSelection" class="content pos-relative m-b-30 m-lr-30 flex flex-col full-grow-no-shrink-no-basis">
    <div class="keno-grid-container">
      <particle-virtual-grid [sourceKey]="sourceKey"
                             sortFieldKey="Name"
                             (valueChanged)="onGridCellValueChange($event)"
                             (fieldSectionChanged)="onFieldSectionChanged($event)"
      >
      </particle-virtual-grid>
    </div>
  </div>
</div>


